import { clientFor, type PageQuery, type PageResult } from '@yc/api-client'

const api = clientFor('/ops/api')

/** 一行应收：按 客户 + 账期 聚合的计费金额。字段与 internal/report/model.go 的 ReceivableRow 一致。 */
export interface ReceivableRow {
  customer_id: number
  customer_code: string
  customer_name: string
  /** 账期 YYYY-MM；未挂结算单的按计费当月归集 */
  period: string
  charge_count: number
  pending_amount: number
  settled_amount: number
  total_amount: number
}

export interface ReceivableQuery extends PageQuery {
  customer?: number
  period?: string
  keyword?: string
}

/** 本页合计：报表是聚合结果，页脚合计让人一眼看出规模（与 wms 报表同套路） */
export function pageTotals(
  rows: ReadonlyArray<ReceivableRow>,
): { charge_count: number; pending_amount: number; settled_amount: number; total_amount: number } {
  const acc = { charge_count: 0, pending_amount: 0, settled_amount: 0, total_amount: 0 }
  for (const row of rows) {
    acc.charge_count += row.charge_count
    acc.pending_amount += row.pending_amount
    acc.settled_amount += row.settled_amount
    acc.total_amount += row.total_amount
  }
  acc.pending_amount = Math.round(acc.pending_amount * 100) / 100
  acc.settled_amount = Math.round(acc.settled_amount * 100) / 100
  acc.total_amount = Math.round(acc.total_amount * 100) / 100
  return acc
}

export const listReceivables = (q: ReceivableQuery): Promise<PageResult<ReceivableRow>> =>
  api.get<PageResult<ReceivableRow>>('/reports/receivables', { ...q })

/**
 * 导出 CSV：同一个路径带 export=csv，后端回 UTF-8 BOM 附件。
 * 导出鉴权是 ops:report:export，在后端处理器里细分，前端按钮同码控入口。
 */
export const exportReceivables = (q: Omit<ReceivableQuery, 'page' | 'size'>): Promise<Blob> =>
  api.getBlob('/reports/receivables', { ...q, export: 'csv' })
